import { useUserToken } from '~/composables/use-user-token'
import { useUserStore } from '~/store/user'

const TOKEN_QUERY_KEYS = ['token', 'refresh_token', 'update_refresh_token'] as const

export default defineNuxtRouteMiddleware(async to => {
  const {
    setAccessToken,
    setRefreshToken,
    consumeUpdateRefreshToken,
    getAccessToken,
    getRefreshToken,
    getUpdateRefreshToken,
    removeAllTokens,
  } = useUserToken()

  const { $axios, $services } = useNuxtApp()

  const userStore = useUserStore()

  if (to.query.token) {
    setAccessToken(String(to.query.token))
  }

  if (to.query.refresh_token) {
    setRefreshToken(String(to.query.refresh_token))
  }

  if (to.query.update_refresh_token) {
    consumeUpdateRefreshToken(String(to.query.update_refresh_token))
  }

  const applyToken = (token: string | null) => {
    if (!$axios) {
      return
    }

    if (token) {
      $axios.defaults.headers.common['Authorization-SF-Token'] = token
    } else {
      delete $axios.defaults.headers.common['Authorization-SF-Token']
    }
  }

  const token = getAccessToken()
  const tokenChanged = !!to.query.token
  const canRefresh = !!getRefreshToken() || !!getUpdateRefreshToken()

  applyToken(token)

  const needAuth = !userStore.isAuthenticated && (token || canRefresh)

  if (needAuth || tokenChanged) {
    try {
      // throwOnTransientError: сетевой сбой не должен выглядеть как протухшая сессия
      let user = token
        ? await $services.userService.getAuthorizedUser({ throwOnTransientError: true })
        : null

      if (!user && canRefresh) {
        const tokens = await $services.userService.getAccessTokenByRefresh()

        if (tokens?.accessToken) {
          setAccessToken(tokens.accessToken)
          if (tokens.refreshToken) {
            setRefreshToken(tokens.refreshToken)
          }
          applyToken(tokens.accessToken)
          user = await $services.userService.getAuthorizedUser({ throwOnTransientError: true })
        }
      }

      if (user) {
        userStore.setAuthorizedUser(user)
      } else {
        userStore.clearUser()
        removeAllTokens()
        applyToken(null)
      }
    } catch (error) {
      // временный сбой бека: сессию не трогаем, токены не удаляем
      console.error('Не удалось проверить сессию', error)
    }
  }

  // токены не должны оставаться в адресной строке: история, Referer, аналитика
  if (TOKEN_QUERY_KEYS.some(key => key in to.query)) {
    const tokenKeys: ReadonlyArray<string> = TOKEN_QUERY_KEYS
    const query = Object.fromEntries(
      Object.entries(to.query).filter(([key]) => !tokenKeys.includes(key))
    )

    return navigateTo({ path: to.path, query, hash: to.hash }, { replace: true })
  }
})
